export const NEWS_PER_PAGE = 16
export const AUTHORS_CENTER_PER_PAGE = 16
export const COLLECTIONS_PER_PAGE = 20
export const AUTHORS_PER_PAGE = 32
export const AUTHORS_DETAIL_PER_PAGE = 20
export const AHEAD_OF_PRINT_PER_PAGE = 16
export const SCIENTIFIC_ADVISORY_BOARD_PER_PAGE = 24
export const EDITORIAL_BOARD_PER_PAGE = 24
export const REVIEWERS_PER_PAGE = 24
export const COLLECTIONS_DETAIL_PER_PAGE = 20
export const SUSTAINABLE_DEVELOPMENT_GOALS_PER_PAGE = 20
export const SUSTAINABLE_DEVELOPMENT_GOALS_DETAIL_PER_PAGE = 20
export const PUBLISHING_SERIES_DETAIL_PER_PAGE = 20
